import React from 'react';
import PropTypes from 'prop-types';
import { BaseDialog } from '@metarouter-private/mr-mui';
import useBulkExport from './useBulkExport';
import BulkExportModalBody from './BulkExportModalBody';
import BulkExportModalActions from './BulkExportModalActions';

const DIALOG_PROPS = { maxWidth: 'xs', fullWidth: true, 'data-test-id': 'bulk-export-modal' };

export default function BulkExportModal({ open, onClose, cluster, earliestSeen, reports }) {
  const { process, totalCount, closeIfNotProcessing } = useBulkExport({
    open,
    onClose,
    cluster,
    earliestSeen,
    reports,
  });

  return (
    <BaseDialog
      DialogProps={{ ...DIALOG_PROPS, open, onClose: closeIfNotProcessing }}
      title="Export All Schemas"
      content={
        <BulkExportModalBody
          status={process.status}
          currentIndex={process.currentIndex}
          totalCount={totalCount}
          error={process.error}
        />
      }
      actions={<BulkExportModalActions status={process.status} onClose={closeIfNotProcessing} />}
    />
  );
}

BulkExportModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  cluster: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }).isRequired,
  earliestSeen: PropTypes.string.isRequired,
  reports: PropTypes.array,
};
